import type { RouteRecordRaw } from 'vue-router';
import headerRoutes from '@/modules/header/header.routes.children';
import { prefixRouteNames } from '@/shared/utils/routes';

export default [
    {
        path: ':workspaceId/annuaire',
        name: 'annuaire',
        component: () => import('./components/AnnuaireContent.vue'),
        meta: {
            title: 'Annuaire',
        },
        children: [
            ...prefixRouteNames('annuaire', headerRoutes)
        ],
    },


] satisfies RouteRecordRaw[];
